import type { UserCredential } from 'firebase/auth';
import { firebaseAuthService } from '@/core/services';
import type { ConfirmationResult } from '@/core/services';

export class VerificarCodigoOtpUseCase {
  async execute(confirmationResult: ConfirmationResult, code: string): Promise<UserCredential> {
    return firebaseAuthService.confirmPhoneVerificationCode(confirmationResult, code);
  }
}
